<template>
  <div class="content-page-blueprint">
    <HerosLoader
      v-if="page.heros"
      :heros="page.heros"
      :parent-page="page.parent"
    />

    <Breadcrumbs />

    <div
      v-if="page.lead"
      class="pt-10 sm:pt-12 md:pt-14 lg:pt-16 xl:pt-20"
      :class="[
        firstComponentIsText
          ? 'pb-2 sm:pb-4 md:pb-6 lg:pb-10 xl:pb-12'
          : 'pb-10 sm:pb-12 md:pb-14 lg:pb-16 xl:pb-20',
      ]"
    >
      <LeadText :lead="page.lead" />
    </div>

    <ComponentsLoader :components="page.components" />
  </div>
</template>

<script setup>
const props = defineProps({
  page: { type: Object, required: true },
})

// check if first component is text
const firstComponentIsText = computed(() => {
  if (Array.isArray(props.page.components) && props.page.components.length) {
    return props.page.components[0]?.type === 'text'
  }

  return false
})
</script>
